<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div class="body-3 grey--text font-weight-light" v-text="title" />

        <h3 class="display-2 font-weight-light text--primary">
          <span class="card-value">{{ value }}</span>
          <small>{{ smallValue }}</small>
        </h3>
      </div>
    </template>

    <v-col cols="12" class="px-0">
      <v-divider />
    </v-col>

    <v-icon :color="subIconColor" size="16" class="ml-2 mr-1">{{
      subIcon
    }}</v-icon>
    <a v-if="subLink" @click="openLink">
      <span
        :class="subTextColor"
        class="caption grey--text font-weight-light"
        v-text="subText"
      />
    </a>
    <a v-else-if="subContent" @click="contentVisible = !contentVisible">
      <span
        :class="subTextColor"
        class="caption grey--text font-weight-light"
        v-text="subText"
      />
      <div v-if="contentVisible" v-html="subContent" />
    </a>
    <span
      v-else
      :class="subTextColor"
      class="caption grey--text font-weight-light"
      v-text="subText"
    />
  </base-material-card>
</template>

<script>
import Card from "./Card";

export default {
  name: "MaterialStatsCard",

  inheritAttrs: false,
  data() {
    return { contentVisible: false };
  },
  props: {
    ...Card.props,
    icon: {
      type: String,
      required: true,
    },
    subLink: {
      type: String,
      default: undefined,
    },
    subContent: {
      type: String,
      default: undefined,
    },
    subIcon: {
      type: String,
      default: undefined,
    },
    subIconColor: {
      type: String,
      default: undefined,
    },
    subTextColor: {
      type: String,
      default: undefined,
    },
    subText: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: undefined,
    },
    smallValue: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    openLink(url) {
      this.$documentViewer.documentViewerRsp.docUrl = this.subLink;
    },
  },
};
</script>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

  .v-card__actions
    flex: 1 0 100%

  .title
    margin-top: 7px

  .card-value
    margin-left: 10px
    color: #9e9e9e !important
</style>
